<template lang="html">
  <div class="trello-announcement" v-if="loaded">
    <div class="announcements" v-if="hasCards">
      <span>Announcements:</span>
      <div
        v-for="(card, index) in filteredCards"
        :key="`announcement-${index}`">
        <p class="card-name">{{card.name}}</p>
        <p>{{card.desc}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Ajax from '@/lib/ajax/ajax'
import notification from '@/mixins/notification'

export default {
  name: 'trello-announcement',

  data() {
    return {
      loaded: false,
      list: {},
      cards: []
    }
  },

  mixins: [notification],

  computed: {
    filteredCards() {
      return this.cards.filter(card => card.idList === this.list.id)
    },

    boardId() {
      return this.$store.state.whiteLabel ? 'jAZ1ZneC' : 'h5zmnze6'
    },

    hasCards() {
      return !!this.filteredCards.length
    }
  },

  methods: {
    getLists() {
      Ajax.request({
        url: `https://api.trello.com/1/boards/${this.boardId}/lists`,
        headers: {'Accept': 'application/json'},

        onSuccess: (xhr) => {
          let lists = JSON.parse(xhr.responseText)
          this.list = lists.find(list => list.name === 'Announcement')
        },

        onError: (xhr) => {}
      })
    },

    getCards() {
      Ajax.request({
        url: `https://api.trello.com/1/boards/${this.boardId}/cards`,
        headers: {'Accept': 'application/json'},

        onSuccess: (xhr) => {
          this.cards = JSON.parse(xhr.responseText)
          this.loaded = true
        },

        onError: (xhr) => {}
      })
    }
  },

  mounted() {
    this.getLists()
    this.getCards()
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.trello-announcement
  display: none

  @include media($media-gt-medium)
    display: block
    width: 100%
    margin-left: 15px
    padding-left: 30px
    border-left: 1px solid rgba(0, 0, 0, 0.15)

  .announcements
    display: flex
    align-items: center

    span
      color: rgba(0, 0, 0, 0.5)

    > div
      margin: 0 $gap-medium 0 $gap-large

  p
    font-size: 10px
    margin: 0
    line-height: 1.5

  .card-name
    font-weight: bold
    text-transform: uppercase
</style>
